module.exports = __webpack_public_path__ + "50e1bd45774b55ef14b111e40d6bfaee.svg";